/*
 * @Author: mayqiyue
 * @Date: 2019-06-05 15:51:55
 * @Last Modified by: mayqiyue
 * @Last Modified time: 2019-06-05 23:39:28
 */

import store from "@/store";
import GeneralUtils from "@/utils/generalUtils";
import * as types from "@/store/constants/types";

let _needRedirectAppCache: boolean;

const LaunchUtils: any = {
  getLaunchParams: () => {
    if (store.state.startUpPolicyModule.launchParams) {
      return store.state.startUpPolicyModule.launchParams;
    } else if (store.state.startUpPolicyModule.startSettingExist) {
      return (
        store.state.startUpPolicyModule.settingLaunchParams ||
        store.state.startUpPolicyModule.defaultLaunchParams
      );
    } else {
      return store.state.startUpPolicyModule.defaultLaunchParams;
    }
  },

  isEmptyAccount: () => {
    return (
      store.state.currentUserId === null || store.state.userList.length === 0
    );
  },

  vipBeforeWelcome: () => {
    if (LaunchUtils.needRedirectApp()) {
      return false;
    }
    const launch = LaunchUtils.getLaunchParams();
    return launch.hasOwnProperty("vip_before_welcome")
      ? launch.vip_before_welcome
      : true;
  },
  withoutWelcome: () => {
    const launch = LaunchUtils.getLaunchParams();
    return launch.hasOwnProperty("without_welcome")
      ? launch.without_welcome
      : true;
  },
  isVipPlanB: () => {
    const launch = LaunchUtils.getLaunchParams();
    return launch.hasOwnProperty("vip_plan") ? launch.vip_plan === "B" : true;
  },

  needRedirectApp: () => {
    if (_needRedirectAppCache !== undefined) {
      return _needRedirectAppCache;
    }
    _needRedirectAppCache =
      (store.getters[types.GETTER_HAS_REDIRECT] &&
        store.getters[types.GETTER_APP_TAKE_DOWN]) ||
      (store.getters[types.GETTER_APP_TAKE_DOWN] &&
        store.getters[types.GETTER_SUPER_PAY_SHOW_ENABLE] &&
          ((store.getters[types.GETTER_SUPER_PAY_PARAMS] &&
        store.getters[types.GETTER_SUPER_PAY_PARAMS].take_down_launch_enabled) ||
              (store.getters[types.GETTER_BACK_UP_APP_SETTING_PARAMS_VALID] &&
              store.getters[types.GETTER_BACK_UP_APP_SETTING_PARAMS_VALID].take_down_launch_enabled)));
    return _needRedirectAppCache;
  },

  needShowWelcome: () =>
    !LaunchUtils.withoutWelcome() && LaunchUtils.isEmptyAccount(),

  /**
   * 从启动进入的主页面的 route 参数
   */
  rootVipRoute: (type: any) => ({
    name: LaunchUtils.isVipPlanB() ? "VipCenterPlanB" : "VipCenter",
    params: {
      routerTransition: type ? type : 'first'
    },
    query: {
      type: "single",
      from: "root",
      popUp: true
    }
  }),

  /**
   * 从启动进入的主页面的 route 参数
   */
  rootMainRoute: () => ({
    name: "Followers",
    params: {
      routerTransition: "frist",
      comeFromNotice: false
    },
    query: {
      from: "root"
    }
  }),

  /**
   * 从启动进入 splash 界面的 router 参数
   */
  rootSplashRoute: () => ({
    name: "Splash",
    params: {
      routerTransition: "frist"
    },
    query: {
      from: "root"
    }
  }),

  getBuyVipFrom: () => store.state.misc.buy_vip_from,
  setBuyVipFrom: (value: string) => {
    store.state.misc.buy_vip_from = value;
  },
  clearBuyVipFrom: () => (store.state.misc.buy_vip_from = undefined)
};

export default LaunchUtils;
